<template>
    <div v-if="loaded" class="nevs-content">
        <ModalAddCustomer :show="showAddCustomerModal" @done="addCustomerDone"></ModalAddCustomer>
        <div v-if="kpdPopup.show" class="nevs-popup-container">
            <div class="nevs-popup">
                <div class="nevs-popup-text">
                    <NevsSelect :nullable="true" :minimumSearchLength="3" v-model="kpdPopup.data.code_kpd" :ajax="'select/product-codes'"></NevsSelect>
                </div>
                <div class="nevs-popup-buttons">
                    <NevsButton class="error" @click="kpdPopup.cancel()">{{
                            $LANG.Get('buttons.cancel')
                        }}
                    </NevsButton>
                    <NevsButton class="success" @click="kpdPopup.save()">{{ $LANG.Get('buttons.ok') }}</NevsButton>
                </div>
            </div>
        </div>
        <div class="nevs-content-top-buttons">
            <NevsButton class="success help-save" @click="saveClick()"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
            <NevsButton class="error help-back" @click="backClick"><i class="fa-solid fa-arrow-left"></i>
                {{ $LANG.Get('buttons.back') }}
            </NevsButton>
        </div>
        <NevsCard class="form form-float">
            <NevsSelect v-model="invoice.customer_id" :ajax="'select/customers'"
                        :error="invoiceValidation.customer_id"
                        :label="$LANG.Get('fields.customer')"></NevsSelect>
            <div v-if="this.selectedCustomer !== null" class="customer-details">
                {{ this.selectedCustomer.address }}<br/>
                {{ this.selectedCustomer.postal_code }} {{ this.selectedCustomer.city }}<br/>
                {{ this.selectedCustomer.country }}<br/>
            </div>
            <NevsButton @click="showAddCustomerModal = true">
                {{ $LANG.Get('buttons.addNewCustomer') }}
            </NevsButton>
        </NevsCard>
        <NevsCard class="form form-float">
            <NevsTextField v-model="invoice.name" :error="invoiceValidation.name"
                           :label="$LANG.Get('fields.name')"></NevsTextField>
            <NevsNumberField v-model="invoice.day" :label="$LANG.Get('fields.day')"
                             :error="invoiceValidation.day"
                             :thousand-separator="''" :decimal-places="0"></NevsNumberField>
            <NevsNumberField v-model="invoice.month" :label="$LANG.Get('fields.month')"
                             :error="invoiceValidation.month"
                             :thousand-separator="''" :decimal-places="0"></NevsNumberField>
            <NevsSelect v-model="invoice.user_id" :ajax="'select/users'"
                        :label="$LANG.Get('fields.user')"></NevsSelect>
            <NevsCheckbox v-model="invoice.active" :label="$LANG.Get('fields.activeM')"></NevsCheckbox>
        </NevsCard>
        <NevsCard class="form form-float">
            <NevsSelect v-if="showCurrency" v-model="invoice.currency" :ajax="'select/currencies'"
                        :error="invoiceValidation.currency"
                        :label="$LANG.Get('fields.currency')"></NevsSelect>
            <NevsSelect v-model="invoice.invoice_sequence_id"
                        :error="invoiceValidation.invoice_sequence_id"
                        :label="$LANG.Get('fields.sequence')" :options="sequences"></NevsSelect>
            <NevsSelect v-model="invoice.locale" :ajax="'select/languages'"
                        :error="invoiceValidation.locale" :label="$LANG.Get('fields.language')"></NevsSelect>
            <NevsSelect v-model="invoice.payment_method_id" :ajax="'select/payment-methods'"
                        :error="invoiceValidation.payment_method_id" :label="$LANG.Get('fields.paymentMethod')"></NevsSelect>
            <NevsSelect v-model="invoice.contract_id" :nullable="true" :ajax="'select/contracts'"
                        :label="$LANG.Get('fields.contract')"></NevsSelect>
        </NevsCard>
        <NevsCard class="items-card">
            <NevsSelect v-model="selectedProduct" :ajax="'select/products'"
                        :error="invoiceValidation.items"
                        :label="$LANG.Get('labels.selectItem')" class="item-select help-item"></NevsSelect>
            <NevsButton class="details-button" @click="toggleDetails()"><i class="fa-solid fa-eye"></i> {{ $LANG.Get('buttons.details') }}</NevsButton>
            <div class="items-container">
                <table v-show="invoice.items.length !== 0" class="items-table">
                    <thead>
                    <tr class="items-table-header">
                        <td v-for="(header, key) in headers" :key="key" :style="{'width': header.width}">
                            {{ header.text }}
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, key) in invoice.items" :key="key">
                        <td class="items-table-buttons">
                            <NevsButton @click="removeItemClick(key)"><i class="fa-solid fa-trash"></i></NevsButton>
                        </td>
                        <td>
                            <NevsTextField v-model="item.description" :readonly="item.product_id!==null"></NevsTextField><br />
                            <NevsTextArea v-if="showDetails" v-model="item.details"></NevsTextArea>
                        </td>
                        <td>
                            <NevsButton v-show="!(item.product_id!==null)" @click="changeKPDClick(key)"><i class="fa-solid fa-pen"></i></NevsButton>
                            {{ item.code_kpd }}
                        </td>
                        <td>
                            <NevsSelect v-model="item.measurement_unit_id" :ajax="'select/measurement-units'"
                                        :readonly="item.product_id!==null"></NevsSelect>
                        </td>
                        <td>
                            <NevsNumberField v-model="item.price"></NevsNumberField>
                        </td>
                        <td>
                            <NevsNumberField v-model="item.quantity" :decimal-places="3" :thousand-separator="''"></NevsNumberField>
                        </td>
                        <td v-if="$store.state.user.client.tax_system && !invoice.ppo">
                            <NevsNumberField v-model="item.tax"></NevsNumberField>
                        </td>
                        <td>
                            <NevsNumberField v-model="item.discount"></NevsNumberField>
                        </td>
                        <td>
                            <NevsNumberField v-model="item.total" :readonly="true"></NevsNumberField>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table v-show="invoice.items.length !== 0" class="summary-table">
                    <tbody>
                    <tr>
                        <td class="sub-table-left">{{ $LANG.Get('labels.additionalDiscount') }} (%):</td>
                        <td class="sub-table-right">
                            <NevsNumberField v-model="invoice.discount" :thousand-separator="''"></NevsNumberField>
                        </td>
                    </tr>
                    <tr v-for="(base, key) in taxBases" :key="key">
                        <td>
                            {{ $LANG.Get('labels.taxBase') }} {{ base.base }} ({{ invoice.currency }}):
                        </td>
                        <td>
                            <NevsNumberField v-model="base.value" :readonly="true"></NevsNumberField>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {{ $LANG.Get('fields.total') }} ({{ invoice.currency }}):
                        </td>
                        <td>
                            <NevsNumberField v-model="total" :readonly="true"></NevsNumberField>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="nevs-clear-float"></div>
            </div>
        </NevsCard>
        <NevsCard class="footer-container">
            <NevsTextArea v-model="invoice.footer" :error="invoiceValidation.footer"
                          :label="$LANG.Get('fields.footer')"></NevsTextArea>
            <NevsCheckbox class="help-ppo" v-model="invoice.ppo" :label="$LANG.Get('fields.ppo')"></NevsCheckbox>
            <NevsTextField v-if="invoice.ppo" v-model="invoice.ppo_text"
                           :label="$LANG.Get('fields.ppoText')"></NevsTextField>
            <NevsSelect class="bank-field" v-if="ibanOptions.length > 1" :label="$LANG.Get('fields.iban')"
                        v-model="invoice.iban" :options="ibanOptions"></NevsSelect>
            <NevsSelect class="bank-field" v-if="swiftOptions.length > 1" :label="$LANG.Get('fields.swift')"
                        v-model="invoice.swift" :options="swiftOptions"></NevsSelect>
        </NevsCard>
    </div>
</template>

<script>
import AutomaticInvoice from '@/models/AutomaticInvoice.js';
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import Big from 'big.js';
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";
import NevsTextArea from "@/components/nevs/NevsTextArea.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import ModalAddCustomer from "@/components/modals/ModalAddCustomer.vue";
import moment from "moment";

export default {
    name: "EntityAutomaticInvoice",
    components: {
        ModalAddCustomer,
        NevsCheckbox,
        NevsTextArea,
        NevsNumberField, NevsTextField, NevsSelect, NevsButton, NevsCard
    },
    data() {
        return {
            loaded: false,
            mode: this.$route.params.mode,
            invoice: new AutomaticInvoice({
                id: this.$route.params.id,
                iban: this.$store.state.user.client.iban[0],
                swift: this.$store.state.user.client.swift[0],
                footer: this.$store.state.user.client['invoice_footer_template_' + this.$store.state.locale],
                locale: this.$store.state.locale,
                payment_method_id: 1,
                user_id: 1
            }),
            invoiceValidation: new AutomaticInvoice({}, true),
            selectedCustomer: null,
            selectedProduct: null,
            taxBases: [],
            tempTaxBases: [],
            total: 0,
            showCurrency: true,
            sequences: [],
            kpdPopup: {
                show: false,
                indexToEdit: null,
                data: {
                    code_kpd: ''
                },
                reset: () => {
                    this.kpdPopup.data = {
                        code_kpd: ''
                    };
                    this.kpdPopup.indexToEdit = null;
                },
                cancel: () => {
                    this.kpdPopup.show = false;
                },
                save: () => {
                    if (this.kpdPopup.data.code_kpd === null) this.kpdPopup.data.code_kpd = '';
                    this.invoice.items[this.kpdPopup.indexToEdit].code_kpd = this.kpdPopup.data.code_kpd;
                    this.kpdPopup.show = false;
                    this.kpdPopup.reset();
                }
            },
            selectedSequenceIsFiskal: false,
            showAddCustomerModal: false,
            showDetails: false
        }
    },
    computed: {
        headers() {
            let headers = [
                {
                    text: '',
                    sortable: false,
                    value: 'actions',
                    width: '50px',
                    class: 'pa-0'
                },
                {
                    text: this.$LANG.Get('fields.description'),
                    sortable: false,
                    value: 'description',
                    class: 'pa-0 description-width'
                },
                {
                    text: this.$LANG.Get('fields.code_kpd'),
                    sortable: false,
                    value: 'kpd',
                    class: 'pa-0 description-width',
                    width: '120px'
                },
                {
                    text: this.$LANG.Get('fields.measurementUnit'),
                    sortable: false,
                    value: 'measurement_unit',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.price') + ' (' + this.invoice.currency + ')',
                    sortable: false,
                    value: 'price',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.quantity'),
                    sortable: false,
                    value: 'quantity',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.discount'),
                    sortable: false,
                    value: 'discount',
                    class: 'pa-0',
                    width: "100px"
                },
                {
                    text: this.$LANG.Get('fields.total') + ' (' + this.invoice.currency + ')',
                    sortable: false,
                    value: 'total',
                    class: 'pa-0',
                    width: "100px"
                }
            ]
            if (this.$store.state.user.client.tax_system && !this.invoice.ppo) {
                headers.splice(6, 0, {
                    text: this.$LANG.Get('fields.tax'),
                    sortable: false,
                    value: 'tax',
                    class: 'pa-0',
                    width: "100px"
                })
            }
            return headers;
        },
        ibanOptions() {
            let options = [];
            let current = this.invoice.iban;
            let currentExists = false;
            for (let iban of this.$store.state.user.client.iban) {
                if (iban === current) currentExists = true;
                options.push({
                    label: iban,
                    value: iban
                });
            }
            if (!currentExists) {
                options.push({
                    label: current,
                    value: current
                });
            }
            return options;
        },
        swiftOptions() {
            let options = [];
            let current = this.invoice.swift;
            let currentExists = false;
            for (let swift of this.$store.state.user.client.swift) {
                if (swift === current) currentExists = true;
                options.push({
                    label: swift,
                    value: swift
                });
            }
            if (!currentExists) {
                options.push({
                    label: current,
                    value: current
                });
            }
            return options;
        }
    },
    watch: {
        'invoice.payment_method_id': function () {
            if (this.loaded && this.mode !== 'edit') {
                this.setDocumentFormatFromPaymentMethod();
            }
        },
        'invoice.locale': function () {
            if (this.loaded) {
                let vm = this;
                for (let i = 0; i < this.invoice.items.length; i++) {
                    if (this.invoice.items[i].product_id !== null) {
                        this.$API.APICall('get', 'products/' + this.invoice.items[i].product_id, {}, (data, success) => {
                            if (success) {
                                let newName = (data.product['name_' + vm.invoice.locale] !== undefined) ? data.product['name_' + vm.invoice.locale] : data.product.name;
                                if (newName != '') vm.invoice.items[i].description = newName;
                            }
                        }, false);
                    }
                }
                this.invoice.footer = this.$store.state.user.client['invoice_footer_template_' + this.invoice.locale];
                this.invoice.ppo_text = this.invoice.ppo ? this.$store.state.user.client['ppo_template_' + this.invoice.locale] : '';
            }
        },
        'invoice.customer_id': function () {
            if (this.invoice.customer_id != null) {
                let vm = this;
                this.$API.APICall('get', 'customers/' + this.invoice.customer_id, {}, (data, success) => {
                    if (success) {
                        vm.selectedCustomer = data.customer;
                    }
                });
            } else {
                this.selectedCustomer = null;
            }
        },
        'selectedProduct': function () {
            if (this.selectedProduct != null) {
                this.addItem();
            }
        },
        'invoice.items': {
            handler: function () {
                this.calculateTotals();
            },
            deep: true
        },
        'invoice.ppo': {
            handler: function () {
                this.calculateTotals();
                if (this.loaded) {
                    this.invoice.ppo_text = this.invoice.ppo ? this.$store.state.user.client['ppo_template_' + this.invoice.locale] : '';
                }
            },
            deep: true
        },
        'invoice.discount': {
            handler: function () {
                this.calculateTotals();
            },
            deep: true
        },
        'invoice.invoice_sequence_id': {
            handler: function () {
                let vm = this;
                this.$API.APICall('get', 'invoice-sequences/' + this.invoice.invoice_sequence_id, {}, (data, success) => {
                    vm.selectedSequenceIsFiskal = (success && data.invoice_sequence !== null && data.invoice_sequence.fiskal);
                }, false);
            },
            deep: true
        }
    },
    methods: {
        // The default document format is configured per payment method, so it follows the selected
        // method on a new automatic invoice. An existing one keeps whatever it was saved with.
        setDocumentFormatFromPaymentMethod() {
            let client = this.$store.state.user.client;
            let field = 'invoice_document_format_id_' + this.invoice.payment_method_id;
            this.invoice.document_format_id = (client[field] !== undefined && client[field] !== null) ? client[field] : 1;
        },
        addCustomerDone(customerId) {
            this.showAddCustomerModal = false;
            if (customerId) {
                this.invoice.customer_id = customerId;
            }
        },
        toggleDetails() {
            this.showDetails = !this.showDetails;
        },
        calculateTotals() {
            this.tempTaxBases = [];
            this.total = Big(0);
            for (let index in this.invoice.items) {
                let item = this.invoice.items[index];
                let total = Big(item.price).times(Big(item.quantity));
                total = Big(total.toFixed(2));
                let item_discount = total.times(Big(item.discount)).div(Big(100));
                item_discount = item_discount.toFixed(2);
                total = total.minus(item_discount);
                total = Big(total.toFixed(2));
                let total_with_discount = total;
                let discount_amount = total_with_discount.times(Big(this.invoice.discount)).div(Big(100));
                discount_amount = Big(discount_amount.toFixed(2));
                total_with_discount = total_with_discount.minus(discount_amount);
                if (this.$store.state.user.client.tax_system && !this.invoice.ppo) {
                    this.addToTempBase(item.tax, total_with_discount);
                }
                this.invoice.items[index]['total'] = total.toFixed(2);
                this.total = this.total.add(total_with_discount.toFixed(2));
            }
            this.taxBases = JSON.parse(JSON.stringify(this.tempTaxBases));
            if (this.$store.state.user.client.tax_system && !this.invoice.ppo) {
                this.total = Big(0);
                for (let index in this.taxBases) {
                    let currentBase = this.taxBases[index];
                    let currentTaxAmount = (Big(currentBase.value).times(Big(currentBase.base)).div(Big(100))).toFixed(2);
                    this.total = this.total.add(currentTaxAmount).add(Big(currentBase.value));
                }
            }
        },
        addToTempBase(base, value) {
            let term = false;
            for (let index in this.tempTaxBases) {
                let currentBase = this.tempTaxBases[index];
                if (currentBase.base === base) {
                    term = true;
                    currentBase.value = Big(currentBase.value).add(Big(value)).toString();
                }
            }
            if (!term) {
                this.tempTaxBases.push({
                    base: base,
                    value: Big(value).toString()
                });
            }
        },
        backClick() {
            if (window.history.length === 1) {
                window.close();
            } else {
                this.$router.back();
            }
        },
        saveClick() {
            let success = true;

            if (this.invoice.customer_id == null) {
                success = false;
                this.invoiceValidation.customer_id = this.$LANG.Get('labels.customerIdMissing');
            } else {
                this.invoiceValidation.customer_id = '';
            }

            if (this.invoice.name === '' || this.invoice.name === null) {
                success = false;
                this.invoiceValidation.name = this.$LANG.Get('labels.nameMissing');
            } else {
                this.invoiceValidation.name = '';
            }

            if (this.invoice.day < 1 || this.invoice.day > 28) {
                success = false;
                this.invoiceValidation.day = this.$LANG.Get('labels.dayInvalid');
            } else {
                this.invoiceValidation.day = '';
            }

            if (this.invoice.month < 0 || this.invoice.month > 12) {
                success = false;
                this.invoiceValidation.month = this.$LANG.Get('labels.monthInvalid');
            } else {
                this.invoiceValidation.month = '';
            }

            let f2_term = this.$HELPERS.CheckF2(this, moment().format('YYYY-MM-DD HH:mm:ss'));

            let itemsValidation = '';
            if (this.invoice.items.length === 0) {
                success = false;
                itemsValidation = this.$LANG.Get('labels.noItems');
            } else {
                itemsValidation = '';
            }
            let termDescription = false;
            let termNegative = false;
            let termKPD = false;
            for (let item of this.invoice.items) {
                if (item.description === '') {
                    termDescription = true;
                }
                if (item.quantity < 0 || item.price < 0) {
                    termNegative = true;
                }
                if (f2_term === 2 && this.selectedCustomer && !this.selectedCustomer.foreign && this.selectedCustomer.company_id !== null && item.code_kpd === '' && this.invoice.payment_method_id == 1) {
                    termKPD = true;
                }
            }
            if (termDescription) {
                if (itemsValidation !== '') {
                    itemsValidation += '\n';
                }
                success = false;
                itemsValidation += this.$LANG.Get('labels.emptyItem');
            }
            if (termNegative) {
                if (itemsValidation !== '') {
                    itemsValidation += '\n';
                }
                success = false;
                itemsValidation += this.$LANG.Get('labels.negativeItem');
            }
            if (termKPD) {
                if (itemsValidation !== '') {
                    itemsValidation += '\n';
                }
                success = false;
                itemsValidation += this.$LANG.Get('labels.KPDRequired');
            }
            this.invoiceValidation.items = itemsValidation;

            let payment_method_term = 1;
            if (f2_term > 0 && this.selectedCustomer && this.selectedCustomer.person_id != null) {
                    payment_method_term = 0;
            }
            if (this.invoice.payment_method_id > payment_method_term && !this.selectedSequenceIsFiskal) {
                success = false;
                this.invoiceValidation.payment_method_id = this.$LANG.Get('labels.fiskalNeeded');
            } else {
                this.invoiceValidation.payment_method_id = '';
            }

            if (success) {
                let data = JSON.parse(JSON.stringify(this.invoice));
                let vm = this;
                let action = 'post';
                let addition = '';
                if (this.mode === 'edit') {
                    action = 'put';
                    addition = '/' + this.invoice.id;
                }
                this.$API.APICall(action, 'automatic-invoices' + addition, data, (data, success) => {
                    if (success) {
                        vm.$CROSS_TAB_BUS.TriggerEvent('reload-automatic-invoices', {});
                        vm.$LOCAL_BUS.TriggerEvent('notification', {text: vm.$LANG.Get('alerts.recordSaved')});
                        if (vm.mode === 'add' || vm.mode === 'copy') {
                            vm.backClick();
                        }
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                });
            }
        },
        addItem() {
            if (this.selectedProduct === null) return;
            if (this.selectedProduct === -1) {
                let newItem = {
                    description: '',
                    details: '',
                    code_kpd: '',
                    price: 0,
                    quantity: 1,
                    tax: this.$store.state.settings.DEFAULT_TAX,
                    discount: 0,
                    measurement_unit_id: (this.$store.state.user.client.default_measurement_unit_id !== null) ? this.$store.state.user.client.default_measurement_unit_id : 1,
                    total: 0,
                    product_id: null
                }
                if (!this.$store.state.user.client.tax_system) newItem.tax = 0;
                this.invoice.items.push(newItem);
                this.$nextTick(() => {
                    this.selectedProduct = null;
                });
            } else {
                let vm = this;
                this.$API.APICall('get', 'products/' + this.selectedProduct, {}, (data, success) => {
                    if (success) {
                        let newItem = {
                            description: (data.product['name_' + vm.invoice.locale] !== undefined) ? data.product['name_' + vm.invoice.locale] : data.product.name,
                            details: '',
                            code_kpd: data.product.code_kpd,
                            price: data.product.price,
                            quantity: 1,
                            tax: data.product.tax,
                            discount: 0,
                            measurement_unit_id: data.product.measurement_unit_id,
                            total: 0,
                            product_id: data.product.id
                        }
                        vm.invoice.items.push(newItem);
                        vm.selectedProduct = null;
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                }, false);
            }
        },
        removeItemClick(index) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.generalRemovalQuestion'), callback: (response) => {
                    if (response) {
                        vm.invoice.items.splice(index, 1);
                    }
                }
            });
        },
        changeKPDClick(index) {
            this.kpdPopup.indexToEdit = index;
            this.kpdPopup.data.code_kpd = this.invoice.items[index].code_kpd;
            if (this.kpdPopup.data.code_kpd === '') this.kpdPopup.data.code_kpd = null;
            this.kpdPopup.show = true;
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', [
            {
                class: 'help-save',
                html: this.$LANG.Get('help.save'),
                left: -100,
                top: 0,
                width: 150
            },
            {
                class: 'help-back',
                html: this.$LANG.Get('help.back'),
                left: 85,
                top: -30,
                width: 300
            },
            {
                class: 'help-item',
                html: this.$LANG.Get('help.item'),
                left: 300,
                top: -30,
                width: 300
            },
            {
                class: 'help-ppo',
                html: this.$LANG.Get('help.ppo'),
                left: 300,
                top: -60,
                width: 500
            }
        ]);

        this.$store.commit('selectMenu', 'automatic-invoices');
        this.$store.commit('selectSubMenu', null);

        this.sequences = this.$store.state.user.invoice_sequences;
        if (this.sequences.length > 0) {
            this.invoice.invoice_sequence_id = this.$store.state.user.default_invoice_sequence_id;
        }

        this.setDocumentFormatFromPaymentMethod();

        if (this.mode === 'add') {
            this.$store.commit('setBreadcrumbs', [
                {
                    label: this.$LANG.Get('modules.automaticInvoices'),
                    link: '/automatic-invoices'
                },
                {
                    label: this.$LANG.Get('modules.newAutomaticInvoice'),
                    link: null
                }
            ]);
            this.$nextTick(() => {
                this.loaded = true;
            });
        } else if (this.mode === 'edit') {
            let vm = this;
            this.$API.APICall('get', 'automatic-invoices/' + this.invoice.id, {}, (data, success) => {
                if (success) {
                    if (data.automatic_invoice !== null) {
                        vm.invoice.Fill(data.automatic_invoice);
                        vm.showDetails = vm.invoice.items.some(item => item.details && item.details !== '');
                        vm.$store.commit('setBreadcrumbs', [
                            {
                                label: vm.$LANG.Get('modules.automaticInvoices'),
                                link: '/automatic-invoices'
                            },
                            {
                                label: data.automatic_invoice.name,
                                link: null
                            }
                        ]);
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
                vm.$nextTick(() => {
                    vm.loaded = true;
                });
            });
        } else if (this.mode === 'copy') {
            let vm = this;
            this.$API.APICall('get', 'automatic-invoices/' + this.invoice.id, {}, (data, success) => {
                if (success) {
                    vm.invoice.id = 0;
                    vm.invoice.customer_id = data.automatic_invoice.customer_id;
                    vm.invoice.currency = data.automatic_invoice.currency;
                    let items = JSON.parse(JSON.stringify(data.automatic_invoice.items));
                    for (let i = 0; i < items.length; i++) {
                        items[i].id = undefined;
                    }
                    vm.invoice.items = items;
                    vm.showDetails = vm.invoice.items.some(item => item.details && item.details !== '');
                    vm.invoice.payment_method_id = data.automatic_invoice.payment_method_id;
                    vm.invoice.ppo = data.automatic_invoice.ppo;
                    vm.invoice.ppo_text = data.automatic_invoice.ppo_text;
                    vm.invoice.discount = data.automatic_invoice.discount;
                    vm.invoice.footer = data.automatic_invoice.footer;
                    vm.invoice.locale = data.automatic_invoice.locale;
                    vm.invoice.name = data.automatic_invoice.name;
                    vm.invoice.day = data.automatic_invoice.day;
                    vm.invoice.month = data.automatic_invoice.month;
                    vm.invoice.active = data.automatic_invoice.active;
                    vm.invoice.user_id = data.automatic_invoice.user_id;

                    vm.$store.commit('setBreadcrumbs', [
                        {
                            label: vm.$LANG.Get('modules.automaticInvoices'),
                            link: '/automatic-invoices'
                        },
                        {
                            label: vm.$LANG.Get('modules.newAutomaticInvoice'),
                            link: null
                        }
                    ]);
                    vm.$nextTick(() => {
                        vm.loaded = true;
                    });
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        }
    }
}
</script>

<style scoped lang="scss">
@use '../../scss/vars' as *;

.tabs {
    margin-bottom: 10px;
    border: 2px $muted-border solid;
    border-bottom: none;
    padding: 5px;
    background: $tabs-background;
    border-radius: 5px 5px 0 0;
}

.tabs .nevs-button {
    border-radius: 0;
    margin-right: 10px;
    background: none;
    color: $font-color;
    padding-bottom: 2px;
}

.tabs .nevs-button.active {
    border-bottom: 2px dotted $font-color;
}

.tab-body {
    padding: 10px;
    margin-top: -10px;
    border: 2px $muted-border solid;
    border-radius: 0 0 5px 5px;
}

.form {
    max-width: 300px;
    margin-bottom: 10px;
}

.form-float {
    width: 300px;
    float: left;
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 15px;
}

.form-float h2 {
    margin: 0 0 5px;
}

.customer-details {
    margin: 5px;
}

.items-card {
    clear: both;
}

.details-button {
    float: right;
    margin-bottom: 5px;
}

.items-container {
    clear: both;
    overflow-x: auto;
    white-space: nowrap;
}

.footer-container {
    margin-top: 10px;
    width: calc(100% - 20px);
}

.item-select {
    max-width: 500px;
}

.items-table {
    width: 100%;
    min-width: 1000px;
}

.items-table-header td {
    font-size: 12px;
    padding-left: 5px;
}

.items-table td {
    vertical-align: top;
}

.items-table-buttons {
    text-align: center;
}

.items-table-buttons span {
    cursor: pointer;
}

/* Match the button box to the field input (same 13px vertical padding) and offset it by the
   field wrapper's 5px top padding, so the buttons line up with the first row of inputs. */
.items-table-buttons .nevs-button {
    padding: 13px;
    margin-top: 5px;
}

.summary-table {
    float: right;
    margin-top: 30px;
    width: 400px;
}

.payments {
    width: calc(100% - 20px);
    max-width: 300px;
}

.payments-list {
    margin-bottom: 10px;
}

.payments table {
    width: 100%;
}

.payment {
    border-bottom: 1px solid $box-form-background;
}

.payments-disclaimer {
    margin: 10px;
}

.nevs-popup {
    max-width: 300px;
}

.payment-date {
    padding: 5px;
}

.f1-checkbox {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid $box-form-background;
}

.f1-notice {
    padding: 5px;
    color: red;
}

.bank-field {
    max-width: 400px;
}

@media only screen and (max-width: 500px) {
    .summary-table {
        float: none;
    }
}

</style>
